export default __webpack_public_path__ + "images/0x6ae96cc93331c19148541d4d2f31363684917092.png";